import _ from 'lodash';
import EventBus from "@/plugins/event-bus";
import {ON_BACS_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
import i18n from "../../../shared/i18n";
import BacsSearch from "@/modules/bacs-payments/models/BacsSearch.model";
import BacsService from "@/modules/bacs-payments/BacsService";

const getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    customer: null,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
    },
    searchModel: new BacsSearch(),
    extraFilters: {},
    expand: 'settlement.customer,created_by,payment',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['batch_id'],
      defaultFields: ['batch_id', 'csv', 'action']
    }
  }
};
const getDefaultFields = () => {
  return [
    {
      key: 'batch_id',
      label: i18n.t('BACS ID'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'settlement',
      label: i18n.t('Settlement No.'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'vendor',
      label: i18n.t('Vendor'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'beneficiary_name',
      label: i18n.t('Account Name/Beneficiary'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'batch_date',
      label: i18n.t('Date'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'paid_amount',
      label: i18n.t('Paid'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'csv',
      label: i18n.t('CSV File'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'created_at',
      label: i18n.t('Created at'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'created_by',
      label: i18n.t('Created by'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
  ]
}

export default {
  namespaced: true,
  state: {
    tableSource: 'bacs',
    tableData: {
      bacs: getDefaultTableData(),
    },
  },
  actions: {
    updateSearchModel({commit, state}, {searchModel, source = null}) {
      commit('updateSearchModel', {
        searchModel: new BacsSearch({
          ...state.tableData[source || state.tableSource].searchModel,
          ...searchModel
        }),
        source
      });
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];


      if (payload) {
        data = {
          ...payload.pagination,
        };
      } else {
        data = {
          ...currentTableData.pagination,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      //Following logic here is because of double filter, from extra filters and user interaction filters
      let type = null
      if (data.type && data.type.split(',').length === 1) {
        type = data.type;
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      if (type) {
        data.type = type;
      }

      const defaultExpand = currentTableData.expand

      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand}${defaultExpand}`;

      return data;
    },
    async getTableData({commit, dispatch}, payload = null) {

      const params = await dispatch('getTableParams', payload);
      EventBus.$emit(ON_BACS_TABLE_GET_TABLE_DATA, {params});
      commit('updateTableLoading', true);

      const response = await BacsService.getBacsBatches(params);

      commit('updateTableLoading', false);
      if (response.success) {
        const {limit, page} = params

        commit('saveBacsResponse', response.body.results)
        commit('updateTableData', {
          pagination: {limit, page, total: response.body.count},
        });
      }
      return response;
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;

      dispatch('getTableData');
    },
  },
  mutations: {
    updateSearchModel: (state, {searchModel, source}) => {
      state.tableData[source || state.tableSource].searchModel = searchModel
    },
    updateTableLoading: (state, payload) => {
      state.tableData[state.tableSource].loading = payload
    },
    updateTableData: (state, payload) => {
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...payload
      }
    },
    saveBacsResponse: (state, payload) => {
      state.tableData[state.tableSource].rows = payload
    },
  }
}